export const TASK_TYPES = {
  DELETE_FINANCIAL_FORM_DATA: "DELETE_FINANCIAL_FORM_DATA",
  DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA: "DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA",
};

export const FETCH_SUPPORT_CASE_DETAILS = "FETCH_SUPPORT_CASE_DETAILS";
export const FETCH_SUPPORT_CASE_DETAILS_SUCCESS =
  "FETCH_SUPPORT_CASE_DETAILS_SUCCESS";
export const FETCH_SUPPORT_CASE_DETAILS_FAILURE =
  "FETCH_SUPPORT_CASE_DETAILS_FAILURE";

export const DELETE_FINANCIAL_FORM_DATA = "DELETE_FINANCIAL_FORM_DATA";
export const DELETE_FINANCIAL_FORM_DATA_SUCCESS =
  "DELETE_FINANCIAL_FORM_DATA_SUCCESS";
export const DELETE_FINANCIAL_FORM_DATA_FAILURE =
  "DELETE_FINANCIAL_FORM_DATA_FAILURE";

export const DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA =
  "DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA";
export const DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA_SUCCESS =
  "DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA_SUCCESS";
export const DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA_FAILURE =
  "DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA_FAILURE";

export const TAKE_SUPPORT_AUTOMATION_BACKUP = "TAKE_SUPPORT_AUTOMATION_BACKUP";
export const TAKE_SUPPORT_AUTOMATION_BACKUP_SUCCESS =
  "TAKE_SUPPORT_AUTOMATION_BACKUP_SUCCESS";
export const TAKE_SUPPORT_AUTOMATION_BACKUP_FAILURE =
  "TAKE_SUPPORT_AUTOMATION_BACKUP_FAILURE";

export const CLEAR_SUPPORT_WORK_AUTOMATION_STATE =
  "CLEAR_SUPPORT_WORK_AUTOMATION_STATE";
